import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Tag({ className, variant = "informational", ...rest }) {
    return (_jsx("span", { className: classNames("cvr-tag", className, {
            "cvr-tag--informational": variant?.startsWith("informational"),
            "cvr-tag--promoted": variant?.startsWith("promoted"),
            "cvr-tag--highlighted": variant?.endsWith("highlighted"),
        }), ...rest }));
}
